import React from 'react'
import Column from '@amzn/meridian/column'
import Text from '@amzn/meridian/text'
import Divider from '@amzn/meridian/divider'
import { AggregatedNotificationItem } from './AggregatedNotificationItem'
import { IAggregatedNotification } from '../types'
import { StoreNotificationHeader } from './StoreNotificationHeader'
import { PENDING_TASKS } from '../constants'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './AggregatedNotificationGroup.scss'

interface IAggregatedNotificationGroupProps {
    storeId: string
    storeName: string
    toolName: string
    aggregatedNotifications: IAggregatedNotification[]
}

export const AggregatedNotificationGroup: React.FC<IAggregatedNotificationGroupProps> = ({
    storeId,
    storeName,
    toolName,
    aggregatedNotifications,
}) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <Column spacing="300">
            <StoreNotificationHeader storeName={storeName} />
            {aggregatedNotifications.length === 0 ? (
                <>
                    <Column spacingInset="300 400" data-testid="zero-pending-tasks">
                        <div className="zero-pending-tasks">
                            <Text type="b200" color="inverted">{t(bundle, PENDING_TASKS, { pendingTaskCount: 0 })}</Text>
                        </div>
                    </Column>
                    <Divider size="small" />
                </>
            ) : (
                <Column spacing="300">
                    {aggregatedNotifications.map((aggNotif, index) => (
                        <AggregatedNotificationItem
                            key={`${storeId}-${index}`}
                            toolName={toolName}
                            notificationMessage={aggNotif.notificationMessage}
                            numPendingTasks={aggNotif.numPendingTasks}
                            message={aggNotif.message}
                            timestamp={aggNotif.mostRecentNotificationTimestamp}
                            toolUrl={aggNotif.toolUrl}
                        />
                    ))}
                </Column>
            )}
        </Column>
    )
}
